import { NgModule } from '@angular/core';
import { FilterIngPipe } from '@app/pipes/filterIng/filterIng.pipe';
import { PlusPipe } from '@app/pipes/plus/plus.pipe';
import { ToArrPipe } from '@app/pipes/toArray/toArray.pipe';
import { AbsolutePathPipe } from './absolute-path/absolute-path.pipe';
import { SafeHtmlPipe } from './safe-html/safe-html.pipe';
@NgModule({
    imports: [
    ],
    declarations: [
        PlusPipe,
        FilterIngPipe,
        ToArrPipe,
        AbsolutePathPipe,
        SafeHtmlPipe
    ],
    exports: [
        PlusPipe,
        FilterIngPipe,
        ToArrPipe,
        AbsolutePathPipe,
        SafeHtmlPipe
    ]
})

export class PipesModule {

}
